<template>
<div id="container" class="container veranstaltungen">
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <div class="fullscreen_background">
        <img src="/static/assets/veranstaltungen/Hintergrund_2860.jpg" />
    </div>
    <div class="content">
            <div class="inner">
                    <div class="ueberschrift">
                        Noch mehr Kinderspass!
                    </div>
                    <div class="content_text">
                            <!-- p>Die Buchhandlung Hugendubel bietet viele lohnenswerte Veranstaltungen für Ihre Kinder. Ob Lesungen oder Mitmachaktionen – bestimmt gibt es auch in Ihrer Hugendubel Buchhandlung ein Event, das Ihrem Kind Freude macht.</p -->
                            <p>Die Buchhandlung Hugendubel bietet viele lohnenswerte Veranstaltungen für Ihre Kinder. Ob Lesungen oder Mitmachaktionen – bestimmt gibt es auch in Ihrer Hugendubel Buchhandlung ein Event, das Ihrem Kind Freude macht.</p>
                    </div>
                    <div class="alphabet">
                        <div class="row1">
                            <span class="alpha A" v-on:click="loadVeranstaltungen('A')">A</span>
                            <span class="alpha B" v-on:click="loadVeranstaltungen('B')">B</span>
                            <span class="alpha C" v-on:click="loadVeranstaltungen('C')">C</span>
                            <span class="alpha D" v-on:click="loadVeranstaltungen('D')">D</span>
                            <span class="alpha E" v-on:click="loadVeranstaltungen('E')">E</span>
                            <span class="alpha F" v-on:click="loadVeranstaltungen('F')">F</span>
                            <span class="alpha G" v-on:click="loadVeranstaltungen('G')">G</span>
                            <span class="alpha H" v-on:click="loadVeranstaltungen('H')">H</span>
                            <span class="alpha I" v-on:click="loadVeranstaltungen('I')">I</span>
                            <span class="alpha J" v-on:click="loadVeranstaltungen('J')">J</span>
                            <span class="alpha K" v-on:click="loadVeranstaltungen('K')">K</span>
                            <span class="alpha L" v-on:click="loadVeranstaltungen('L')">L</span>
                            <span class="alpha M" v-on:click="loadVeranstaltungen('M')">M</span>
                            <span class="alpha N" v-on:click="loadVeranstaltungen('N')">N</span>
                        </div>
                        <div class="row2">
                            <span class="alpha O" v-on:click="loadVeranstaltungen('O')">O</span>
                            <span class="alpha P" v-on:click="loadVeranstaltungen('P')">P</span>
                            <span class="alpha Q" v-on:click="loadVeranstaltungen('Q')">Q</span>
                            <span class="alpha R" v-on:click="loadVeranstaltungen('R')">R</span>
                            <span class="alpha S" v-on:click="loadVeranstaltungen('S')">S</span>
                            <span class="alpha T" v-on:click="loadVeranstaltungen('T')">T</span>
                            <span class="alpha U" v-on:click="loadVeranstaltungen('U')">U</span>
                            <span class="alpha V" v-on:click="loadVeranstaltungen('V')">V</span>
                            <span class="alpha W" v-on:click="loadVeranstaltungen('W')">W</span>
                            <span class="alpha X" v-on:click="loadVeranstaltungen('X')">X</span>
                            <span class="alpha Y" v-on:click="loadVeranstaltungen('Y')">Y</span>
                            <span class="alpha Z" v-on:click="loadVeranstaltungen('Z')">Z</span>
                        </div>
                    </div>
            </div>
    </div>
    <vuescrollbar tag="div" class="resultat_anzeige" id="resultat_anzeige">
        <!-- Klicke links auf den Anfangsbuchstaben deiner Stadt! -->
      Hier können Sie sich in Kürze über unsere Kinderveranstaltungen informieren.
    </vuescrollbar>
    <stoppuhr />
    <div class="lautsprecher z30">
            <img class="img" src="/static/assets/frontpage/Lautsprecher.png" />
    </div>
    <div class="gigi">
            <img class="img" src="/static/assets/veranstaltungen/Gigi.png" width="175" height="252"/>
    </div>
    <div class="hui">
            <img class="img" src="/static/assets/veranstaltungen/Hui.png" width="144" height="166"/>
    </div>
    <div class="libero">
            <img class="img" src="/static/assets/veranstaltungen/Libero.png" />
    </div>
    <div class="dubix">
            <img class="img" src="/static/assets/veranstaltungen/Dubix.png" />
    </div>
</div>
</template>

<script>
/* eslint-disable */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
import VueScrollBar from 'vue-perfect-scrollbar'

export default {
  name: 'Veranstaltungen',
  data () {
    return {
      who: 'Veranstaltungen',
      veranstaltungen: {}
    }
  },
  methods: {
    loadVeranstaltungen (x) {
      if ($('.alphabet .alpha.' + x).hasClass('available')) {
        console.log('Anzeigen von Buchstabe ', x)
        var v = this.$data.veranstaltungen[x]
        $('.alphabet .alpha').removeClass('active')
        $('.alphabet .alpha.' + x).addClass('active')
        var html = ''
        for (var i = 0; i < v.length; i++) {
          html = html + '<div ' + this.$options._scopeId + ' class="termin"><div ' + this.$options._scopeId + ' class="header"><h2 ' + this.$options._scopeId + '>' + v[i].stadt + '</h2></div><div ' + this.$options._scopeId + ' class="datum">' + v[i].datum + '</div><div class="inhalt"><h3 ' + this.$options._scopeId + '>' + v[i].titel + '</h3><p ' + this.$options._scopeId + '>' + v[i].content + '</p></div><div class="veranstaltungsort">' + v[i].ort + '</div></div>'
        }

        $('.resultat_anzeige').html(html)
      }
    }
  },
  beforeMount () {
    console.log('beforeMount called')
    var self = this
    $.ajax({
      url: '/static/assets/scripts/veranstaltungen.json',
      dataType: 'json',
      method: 'GET',
      success: function (data) {
        self.$data.veranstaltungen = data
        var buchstaben = Object.keys(self.$data.veranstaltungen)
        $('.alpha', self.$el).removeClass('available')
        for (var i = 0; i < buchstaben.length; i++) {
          var k = '.alpha.' + buchstaben[i]
          $(k, self.$el).addClass('available')
        }
        $('.alpha.' + buchstaben[0]).click()
      },
      error: function (error) {
        console.log(error)
      }
    })
  },
  mounted () {
    this.$ga.page(this.$router)
    // console.log('veranstaltungen: ', this.$data.veranstaltungen)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
      window.hintergrundSound.pause()
    } catch (e) {}
  },  
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

.veranstaltungen .himmel { position: absolute; top: 0px; left: 0; width: 100%; height: auto; }
.veranstaltungen .content { position: absolute; top: 318px; left: 330px; width: 500px; height: auto;  font-size: 16pt; font-family: 'Open Sans'; font-weight: 400;}
.veranstaltungen .content .inner {position:relative;}
.veranstaltungen .content .inner .ueberschrift { position: absolute; top: 0; left: 0; width: 100%; height: auto; color: white; font-family: FrozenMemory; font-size: 36px; }
.veranstaltungen .content .inner .content_text  { position: absolute; top: 50px; left: 0; width: 100%; height: auto;}

/*.veranstaltungen .alphabet {
    position: absolute;
    top: 325px;
    font-family: FrozenMemory;
    font-size: 36px;
    color: #5baacb;
}
*/
.veranstaltungen .alphabet {
    position: absolute;
    top: 255px;
    font-family: FrozenMemory;
    font-size: 36px;
    color: #5baacb;
}



.veranstaltungen .alphabet .available {
    color: #3287aa;
    cursor: pointer;
}

.veranstaltungen .alphabet .active {
    color: #3287aa;
    /* text-shadow: -3px 0 white, 0 3px white, 3px 0 white, 0 -3px white;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: white;*/
    -webkit-text-stroke: 2px white;
  /* If we weren't using text-shadow, we'd set a fallback color
     and use this to set color instead
    -webkit-text-fill-color: white; */
    text-shadow:
    3px 3px 0 #FFFFFF,
    /* Simulated effect for Firefox and Opera
       and nice enhancement for WebKit */
   -1px -1px 0 #FFFFFF,
    1px -1px 0 #FFFFFF,
   -1px  1px 0 #FFFFFF,
   /*  1px  1px 0 #FFFFFF; */
}

.veranstaltungen .resultat_anzeige {
    position: absolute;
    top: /* 287px; */ 295px;
    right: 330px;
    width: 500px;
    height: 500px;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    /* overflow-y: scroll; 
    color: #3e3d40; */
    word-spacing: 6px;
}

.veranstaltungsort {
    font-size: 85%;
}
.datum {
    color: #FFFFFF;
    font-size: 85%;
    margin-top: -10px;
}

.row1, .row2 { width: 100%; }
.row2 { margin-left: 20px; }

.resultat_anzeige h2 { font-family: FrozenMemory; font-size: 36px; color: #0b7fb0; /* text-shadow: -3px 0 white, 0 3px white, 3px 0 white, 0 -3px white; */
    -webkit-text-stroke-width: 1.5px;
    -webkit-text-stroke-color: white; }

.veranstaltungen .gigi { position: absolute; top: 817px; left: 624px; height: auto; }
.veranstaltungen .gigi {animation: gigi_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes gigi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.veranstaltungen .hui { position: absolute; top: 866px; left: 872px; height: auto; }
.veranstaltungen .hui {animation: hui_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hui_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.veranstaltungen .libero { position: absolute; top: 916px; left: 1538px; height: auto;  }
.veranstaltungen .libero {animation: libero_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes libero_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.veranstaltungen .dubix { position: absolute; top: 807px; left: 424px; height: auto; }
.veranstaltungen .dubix {animation: dubix_erscheint 0.5s ease-out; animation-delay: 0s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
</style>



// WEBPACK FOOTER //
// src/components/Veranstaltungen.vue